import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Documentation from './components/Documentation';
import Structure from './components/Structure';
import Footer from './components/Footer';
import Chat from './components/Chat';
import LoadingScreen from './components/LoadingScreen'; // Import komponen loading
import './App.css'; 

function App() {
  const [loading, setLoading] = useState(true);
  const [heroOpacity, setHeroOpacity] = useState(1);

  // 1. Logika Loading Screen
  useEffect(() => {
    const handleLoad = () => {
      // Memberi jeda 2 detik agar animasi loader terlihat elegan
      setTimeout(() => setLoading(false), 2000);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  // 2. Logika Scroll Fade Hero
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const newOpacity = 1 - scrollPosition / 600;
      setHeroOpacity(newOpacity < 0 ? 0 : newOpacity);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {/* 3. Preloader dengan AnimatePresence */}
      <AnimatePresence mode="wait">
        {loading && <LoadingScreen key="loader" />}
      </AnimatePresence>

      {/* Konten Utama hanya dirender/ditampilkan maksimal saat loading selesai */}
      {!loading && (
        <>
          <Navbar />

          {/* Hero Section */}
          <div style={{ 
            opacity: heroOpacity, 
            transition: 'opacity 0.1s ease-out',
            visibility: heroOpacity <= 0 ? 'hidden' : 'visible',
            position: 'fixed', 
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 1
          }}>
            <Hero />
          </div>

          {/* Main Content */}
          <main 
            id="main-content" 
            style={{ 
              position: 'relative', 
              zIndex: 2, 
              marginTop: '100vh', 
              background: '#050a18' 
            }}
          >
            <Structure />
            <Documentation />
            <Footer />
          </main>

          <Chat />
        </>
      )}
    </div>
  );
}

export default App;